import type { ColumnDef } from "@tanstack/react-table";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import AppRelationTable from "../appRelationTable";
import AppTable from "../appTable";
import RequiredFunctionTable from "../requiredFunctionTable";
import styles from "./index.module.scss";

interface AppOption {
  appid: number;
  appname: string;
}

interface AppDesignTabsProps {
  tabTitles: string[];
  dataSets: object[][];
  columns: Array<ColumnDef<object>[]>;
  updateData: (
    rowIndex: number,
    columnId: string,
    value: string | number,
    tabIndex: number,
  ) => void;
  isEditable: boolean;
  onTabChange: (tabIndex: number) => void; // タブ変更のコールバック
  appOptions?: AppOption[];
}

const AppDesignTabs = ({
  dataSets,
  columns,
  tabTitles,
  updateData,
  isEditable,
  onTabChange,
  appOptions = [],
}: AppDesignTabsProps) => {
  const handleTabClick = (index: number) => {
    onTabChange(index); // 親にタブ変更を通知
  };
  return (
    <Tabs className={styles["tab"]}>
      <TabList className={styles["tab-list"]}>
        {tabTitles.map((title, index) => (
          <Tab
            key={index}
            className={styles["tab-list-name"]}
            selectedClassName={styles["tab-list-name--selected"]}
            onClick={() => handleTabClick(index)}
          >
            {title}
          </Tab>
        ))}
      </TabList>

      <TabPanel key={0} className={styles["custom-tab-panel"]}>
        <h2 className={styles["tab-title"]}>{tabTitles[0]}</h2>
        <AppTable
          key={`app-table-${isEditable}`}
          data={dataSets[0] || []}
          columns={columns[0] || []}
          updateData={(rowIndex, columnId, value) => updateData(rowIndex, columnId, value, 0)}
          isEditable={isEditable}
        />
      </TabPanel>

      <TabPanel key={1} className={styles["custom-tab-panel"]}>
        <h2 className={styles["tab-title"]}>{tabTitles[1]}</h2>
        <AppRelationTable
          data={dataSets[1] || []}
          columns={columns[1] || []}
          updateData={(rowIndex, columnId, value) => updateData(rowIndex, columnId, value, 1)}
          isEditable={isEditable}
          appOptions={appOptions}
        />
      </TabPanel>

      <TabPanel key={2} className={styles["custom-tab-panel"]}>
        <h2 className={styles["tab-title"]}>{tabTitles[2]}</h2>
        <RequiredFunctionTable
          data={dataSets[2] || []}
          columns={columns[2] || []}
          updateData={(rowIndex, columnId, value) => updateData(rowIndex, columnId, value, 2)}
          isEditable={isEditable}
          appOptions={appOptions}
        />
      </TabPanel>
    </Tabs>
  );
};

export default AppDesignTabs;
